import React from 'react';

export default class Preloader extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate() {
        if(this.props.status === true) {
            document.querySelector('body').style.overflow = 'hidden';
        }
        else {
            document.querySelector('body').style.overflow = '';
        }
    }
    render() {
        return (
            <div className={`preloader ${!this.props.status ? 'preloader--hide' : ''}`}>
                <div className="preloader__ring"><div></div><div></div><div></div><div></div></div>
            </div>
        )
    }
}